import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import {
  getUnreadCount,
  getAllNotificaition,
  // markNotificationAsRead,
  markAnyNotificationAsRead,
  markAllNotificationAsRead,
} from "@/api/notificationService";
import type { INotification } from "@/types/notification";

type NotificationPage = {
  items?: INotification[];
  page: number;
  totalPages: number;
};

export const useNotifications = (
  page: number,
  limit: number,
  unRead?: string | null,
) => {
  const unReadParam: string | undefined = unRead ?? undefined;
  return useQuery({
    queryKey: ["notifications", page, limit, unReadParam],
    queryFn: () => getAllNotificaition(page, limit, unReadParam),
  });
};

export const useInfiniteNotifications = (unRead?: boolean) => {
  const unReadParam: string | null | undefined =
    typeof unRead === "boolean" ? String(unRead) : undefined;

  return useInfiniteQuery<NotificationPage>({
    queryKey: ["notifications-infinite", unRead],
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }: { pageParam?: unknown }) => {
      const limit = 2;
      const page = typeof pageParam === "number" ? pageParam : 1;
      const data = await getAllNotificaition(page, limit, unReadParam);
      return {
        items: data.items ?? data.data ?? [],
        page: data.page,
        totalPages: data.totalPages,
      };
    },
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
  });
};

export const useUnreadCount = () => {
  return useQuery({
    queryKey: ["notifications", "unread-count"],
    queryFn: () => getUnreadCount(),
    initialData: () => 0,
  });
};

export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => markAnyNotificationAsRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      queryClient.invalidateQueries({
        queryKey: ["notifications", "unread-count"],
      });
    },
    onError: (error) => {
      console.error("Failed to mark notification as read", error);
    },
  });
};

export const useAllMarkNotificationAsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => markAllNotificationAsRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      queryClient.invalidateQueries({ queryKey: ["notifications-infinite"] });
      queryClient.invalidateQueries({
        queryKey: ["notifications", "unread-count"],
      });
    },
    onError: (error) => {
      console.error("Failed to mark notification as read:", error);
    },
  });
};
